interface Props {
  id: string
  label: string
  placeholder: string
  name?: string
  errorMessage?: string | null
  rows?: number
}

const TextArea = ({
  id,
  label,
  placeholder,
  name,
  errorMessage,
  rows,
}: Props) => (
  <>
    <label htmlFor={id} hidden aria-hidden="true" className="hidden">
      {label}
    </label>
    <textarea
      id={id}
      name={name || id}
      placeholder={placeholder}
      required
      className={`border bg-black text-[13px] rounded p-[26px] text-white w-full outline-none h-min ${
        errorMessage
          ? 'focus:border-[#ff3547] border-[#ff3547]'
          : 'focus:border-[#6ebb1d] border-[#4A4D4E] mb-4'
      }`}
      rows={rows}
    />
    <p
      className={`text-sm text-[#ff3547] text-center ${
        errorMessage
          ? 'visible opacity-100 p-2 h-full'
          : 'invisible opacity-0 h-0'
      } transition-all duration-300`}
    >
      {errorMessage}
    </p>
  </>
)

export default TextArea
